<template>
    <div>
        <a-modal :title="title" v-model="visible" @ok="handleOk" class="red-dashed-model">
            <div class="red-dashed-box">
                <textarea name="" placeholder="请输入红冲的原因" v-model="textarea" ref="inputs1" id="" cols="30" rows="10" @keyup.enter="handleOk" class="textarea-text"></textarea>
            </div>
        </a-modal>
        <a-modal :title="title2" v-model="visible1" @ok="handleOk1"  @cancel="onCancel"  class="red-dashed-model">
            <div class="red-dashed-box">
                <textarea placeholder="请输入理由，非必填" v-model="textarea1" cols="30" rows="10" ref="inputs" @keyup.enter="handleOk1" class="textarea-text"></textarea>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
  name: 'redDashed',
  data () {
    return {
      title: '红冲',
      visible: false,
      textarea: '',
      visible1: false,
      textarea1: '',
        title2:'审核'
    }
  },
  methods: {
    show (data) {
      this.visible = true
        this.textarea = ''
        setTimeout(()=>{
            this.$refs.inputs1.focus()
        })
    },
    cancel () {
      this.visible = false
        this.visible1 = false
    },
    handleOk () {
        this.visible = false
        this.$emit('onConfirmRedDash',this.textarea)
    },
      onCancel(){
        this.visible1 = false
      },
      show1 () {
          this.visible1 = true
          this.textarea1 = ''
          setTimeout(()=>{
              this.$refs.inputs.focus()
          })
      },
      handleOk1(){
          this.visible1 = false
          this.$emit('onConfirmOrder',this.textarea1)
      }
  }
}
</script>
<style lang="scss">
.red-dashed-model {
  width: 560px !important;
  .ant-modal-content {
    height: 330px;
    border-radius: 10px;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
    }
    .ant-modal-body {
      height: 175px;
      display: flex;
      justify-content: center;
      padding: 15px 0 0 0;
    }
    .ant-btn {
      width: 140px;
      border-radius: 6px !important;
    }

    .red-dashed-box {
      width: 420px;
      height: 136px;
      .textarea-text {
        width: 420px;
        height: 136px;
        padding: 10px;
        background: rgba(250, 250, 250, 1);
        border: 1px solid rgba(230, 230, 230, 1);
        border-radius: 2px;
        font-size: 14px;
        line-height: 1.5;
        outline: none;
      }
      ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #aaaaaa;
        font-size: 14px;
      }

      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #aaaaaa;
        font-size: 14px;
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #aaaaaa;
        font-size: 14px;
      }
    }
  }
}
</style>
